import type { SafeRecord } from '@cronos-app/utils';

export enum FeatureFlag {
  ContentfulBanners,
  ZkEvm101EarnPoints,

  TopUpTestService,
}

export const isFeatureEnabled = (flag: FeatureFlag) =>
  !!configs[process.env.APP_ENV]?.[flag];

const configs: SafeRecord<
  typeof process.env.APP_ENV,
  Partial<SafeRecord<FeatureFlag, true>>
> = {
  sta: {
    [FeatureFlag.TopUpTestService]: true,
  },
  uat: {},
  prod: {},
};
